'use strict';

/* global gtag */

/* ─── PRODUCT DATABASE ───────────────────────────────────────────────────────
   Images are injected at runtime from the Liquid JSON script tag.
   URLs are absolute so they work from any page context.
──────────────────────────────────────────────────────────────────────────── */

const products = {
  dcop: {
    name: 'Contoured Orthopedic Pillow',
    tag: 'BEST SELLER \u2022 1,310+ Reviews',
    price: '$129.99',
    url: 'https://dosaze.com/collections/neck-pain/products/contoured-orthopedic-pillow',
    image: '',
    points: [
      'Contoured shape with elevated side bolsters fills your shoulder gap and keeps neck + spine aligned in every sleep position \u2014 back, side, stomach, or combination',
      'Proprietary CertiPUR-US\u00AE certified memory foam blend (tested across ~50 formulations) delivers the perfect balance of support and comfort without falling flat',
      'Naturally cooling bamboo rayon cover, OEKO-TEX Standard 100 certified, with removable/washable design \u2014 comes in Standard and Thick heights to match your body',
    ],
  },
  thermacoolPillow: {
    name: 'ThermaCool Adjustable Pillow',
    price: '$149.99',
    url: 'https://dosaze.com/collections/neck-pain/products/dosaze-thermacool-adjustable-pillow',
    image: '',
    points: [
      'Triple-cooling system: ice-cold ThermaCool cover (highest QMAX rating vs cotton/bamboo/tencel), ventilated memory foam core with heat-cycling shafts, and adjustable cooling fill',
      'Hybrid double-foam construction \u2014 one side is a molded gel memory foam core for firm support, the other is adjustable plush fill you can add/remove for personalized loft',
      'CertiPUR-US\u00AE certified foam + OEKO-TEX Standard 100 cover \u2014 works for side, back, and stomach sleepers who need both cooling AND customizable support',
    ],
  },
  wedgePillow: {
    name: 'Therapeutic Cooling Wedge Pillow',
    price: '$119.99',
    url: 'https://dosaze.com/collections/snoring-relief/products/dosaze-therapeutic-cooling-wedge-pillow',
    image: '',
    points: [
      'Gentle incline elevation opens airways to reduce snoring and keeps stomach acid below the esophagus to relieve GERD/acid reflux symptoms naturally',
      'ThermaCool cover with icy-cold gel layer underneath \u2014 doesn\u2019t just feel cold initially, it stays cold throughout the night for hours of relief',
      'Promotes proper spinal alignment by elevating the upper body, distributing weight evenly to alleviate pressure points on back and neck',
    ],
  },
  thermacoolCase: {
    name: 'ThermaCool Pillow Case',
    price: '$34.99',
    url: 'https://dosaze.com/products/thermacool-pillow-case',
    image: '',
    points: [
      'Instant cool-to-the-touch ThermaCool fabric \u2014 temperature-regulating material that manages moisture and heat throughout the entire night',
      'Easiest cooling upgrade: fits on any existing pillow (including all Dosaze pillows) to add immediate temperature regulation without replacing your pillow',
      '60-night guarantee \u2014 if it isn\u2019t the coolest pillowcase you\u2019ve tried, return it free with no shipping or processing fees',
    ],
  },
  thermacoolSheets: {
    name: 'ThermaCool Sheet Set',
    price: '$139.99',
    url: 'https://dosaze.com/collections/hotsleepers/products/dosaze-thermacool-sheet-set-1',
    image: '',
    points: [
      'ThermaCool fabric manages moisture and heat \u2014 absorbs moisture beneath the sheets and channels heat away from your body, preventing vapor buildup',
      'Proprietary bamboo blend feels luxuriously softer than cotton while delivering superior breathability and moisture-wicking performance',
      'Complete set (fitted sheet, flat sheet, pillowcases) with a 60-night guarantee \u2014 if they don\u2019t keep you cooler, return free for a full refund',
    ],
  },
  thermacoolTopper: {
    name: 'ThermaCool Mattress Topper',
    price: '$299.99',
    url: 'https://dosaze.com/products/dosaze-thermacool-mattress-topper-revamp',
    image: '',
    points: [
      'Embedded graphite-infused ThermaCool Bands placed where your body generates the most heat \u2014 targeted, long-lasting cooling that doesn\u2019t fade after 15 minutes',
      '3 inches of premium CertiPUR-US\u00AE certified memory foam with breathable airflow design for body-contouring support that keeps you aligned and cool',
      'Reinforced elastic securing bands at all four corners lock the topper in place \u2014 no bunching, sliding, or shifting no matter how much you move',
    ],
  },
  thermacoolComforter: {
    name: 'ThermaCool Comforter',
    price: '$199.99',
    url: 'https://dosaze.com/collections/hotsleepers/products/thermacool-comforter',
    image: '',
    points: [
      '30% Phase-Change Micro-Gel fill (NASA-inspired tech) actively absorbs excess body heat when you\u2019re warm and releases it as you cool \u2014 continuous temperature balance all night',
      'Dual-sided design: silky cool-to-touch performance blend on one side, naturally smooth breathable TENCEL\u2122 on the other \u2014 flip based on the season',
      'TENCEL\u2122 Lyocell fibers absorb up to 68% more moisture than polyester \u2014 you stay dry and comfortable even in humid environments',
    ],
  },
  dreamAlignTopper: {
    name: 'DreamAlign Back Relief Mattress Topper',
    price: '$319.99',
    url: 'https://dosaze.com/products/dreamalign-back-relief-mattress-topper-white',
    image: '',
    points: [
      '3-zone targeted support: firmer middle zone prevents your midsection from sinking (the \u2018reverse rainbow\u2019 effect), while softer head and leg zones cradle pressure points',
      'Dual-layer construction \u2014 top comfort layer relieves pressure points, bottom support layer provides zoned spinal alignment; most toppers only have one layer',
      'Cooling bamboo cover + 100% made and manufactured in the USA with CertiPUR-US\u00AE certified foam \u2014 enhanced elastic corner straps keep it locked in place',
    ],
  },
  dreamAlignSideTopper: {
    name: 'DreamAlign Side Sleeper 3-Zoned Topper',
    price: '$319.99',
    url: 'https://dosaze.com/products/dreamalign-side-sleeper-mattress-topper-3-zoned',
    image: '',
    points: [
      'Specifically engineered for side sleepers \u2014 three zones with variable foam densities target shoulders, hips, and legs where side sleepers bear the most pressure',
      'Dual-layer memory foam construction with a pressure-relieving comfort layer on top and a zoned support layer below \u2014 keeping your spine neutral regardless of body type',
      'Cooling bamboo cover with enhanced elastic straps for a secure fit \u2014 works on mattresses, pull-out couches, and more without slipping or sliding',
    ],
  },
  dreamAlignHybrid: {
    name: 'DreamAlign Hybrid Back Relief Mattress',
    price: 'From $899',
    url: 'https://dosaze.com/products/dosaze-dreamalign-hybrid-back-relief-mattress',
    image: '',
    points: [
      'AirFoam\u2122 targets 7 key pressure points to ease pain \u2014 outperforms standard memory foam and coils in pressure distribution',
      'OrthoFlex Tri-Zone Coils\u2122 provide firmer support in the middle to keep your spine naturally aligned \u2014 solving the \u2018reverse rainbow\u2019 sinking problem',
      'Designed and crafted in Los Angeles with medium-firm feel (research-proven ideal firmness for back pain relief) \u2014 365-night trial with free returns',
    ],
  },
  dreamAlignPro: {
    name: 'DreamAlign Pro Back Relief Mattress',
    price: 'From $1,199',
    url: 'https://dosaze.com/products/dosaze-dreamalign-pro-back-relief-mattress',
    image: '',
    points: [
      'Patented pressure-relief Gel Grid targets hard contact points (hips, elbows, ribs, ankles) combined with OrthoFlex Tri-Zone Coils\u2122 for hybrid support',
      'Reduces back pain by up to 48% and improves sleep quality by 55% \u2014 combines every pain-relief technology Dosaze offers into a single mattress',
      'Premium uncompromising construction \u2014 designed to deliver over a decade of pain-free sleep; 365-night trial, free returns, crafted in Los Angeles',
    ],
  },
};

/* ─── DECISION TREE ──────────────────────────────────────────────────────────
   Mirrors the React dosaze-quiz-tree.jsx logic exactly.
   Nodes: { id, question, subtitle, options: [ { label, icon, next|result } ] }
   Leaves: { result: { title, description, products: [...productRefs] } }
──────────────────────────────────────────────────────────────────────────── */

const tree = {
  id: 'q1',
  question: 'Are you dealing with pain during or after sleep?',
  subtitle: 'This helps us separate pain-focused solutions from comfort and temperature solutions',
  options: [
    {
      label: 'Yes, I wake up in pain',
      icon: '\uD83D\uDE23',
      next: {
        id: 'q2a',
        question: 'Where do you feel it most?',
        subtitle: 'Different products target different pain zones',
        options: [
          {
            label: 'Neck, head, or shoulders',
            icon: '\uD83D\uDD34',
            next: {
              id: 'q3a',
              question: 'Do you also struggle with overheating at night?',
              subtitle: 'We can solve both pain AND temperature in one setup',
              options: [
                {
                  label: 'Yes, I sleep hot too',
                  icon: '\uD83D\uDD25',
                  result: {
                    title: 'Cooling + Neck Relief',
                    description: 'You need targeted cervical alignment AND temperature regulation. The DCOP handles alignment while the ThermaCool Adjustable adds triple-cooling with customizable support.',
                    products: [products.dcop, products.thermacoolPillow],
                  },
                },
                {
                  label: 'No, just the pain',
                  icon: '\uD83D\uDC4D',
                  result: {
                    title: 'Maximum Neck & Head Support',
                    description: 'Our #1 best-selling pillow for neck alignment, plus the wedge for elevated support if you also deal with tension headaches from congestion or posture.',
                    products: [products.dcop, products.wedgePillow],
                  },
                },
              ],
            },
          },
          {
            label: 'Back, hips, or joints',
            icon: '\uD83D\uDD34',
            next: {
              id: 'q3b',
              question: 'Are you looking to upgrade your mattress or improve what you have?',
              subtitle: 'We have solutions from topper-level upgrades to full mattress replacements',
              options: [
                {
                  label: 'Full mattress upgrade',
                  icon: '\uD83D\uDECF\uFE0F',
                  result: {
                    title: 'Complete Back Relief Mattress',
                    description: 'The Hybrid uses AirFoam\u2122 + OrthoFlex Tri-Zone Coils\u2122 for balanced support. The Pro adds a patented Gel Grid for maximum pressure-point relief. Both include a 365-night trial.',
                    products: [products.dreamAlignHybrid, products.dreamAlignPro],
                  },
                },
                {
                  label: 'Enhance my current mattress',
                  icon: '\u2728',
                  next: {
                    id: 'q3b2',
                    question: 'How do you sleep most often?',
                    subtitle: 'Our toppers are engineered differently depending on your primary sleep position',
                    options: [
                      {
                        label: 'Mostly on my back',
                        icon: '\uD83D\uDECC',
                        result: {
                          title: 'Back Sleeper Topper',
                          description: 'The DreamAlign Back Relief Topper\u2019s firmer middle zone prevents your midsection from sinking while the comfort layer relieves pressure points. Dual-layer, 3-zone, USA-made.',
                          products: [products.dreamAlignTopper],
                        },
                      },
                      {
                        label: 'Mostly on my side',
                        icon: '\uD83D\uDCA4',
                        result: {
                          title: 'Side Sleeper Topper',
                          description: 'The DreamAlign Side Sleeper Topper targets shoulders, hips, and legs with variable foam densities specifically calibrated for how side sleepers distribute pressure.',
                          products: [products.dreamAlignSideTopper],
                        },
                      },
                      {
                        label: 'I switch positions',
                        icon: '\uD83D\uDD04',
                        result: {
                          title: 'Choose Your Topper',
                          description: 'Both toppers use dual-layer, 3-zone construction with cooling bamboo covers. The Back Relief has a firmer center zone; the Side Sleeper targets shoulder and hip pressure. Pick based on where you feel pain most.',
                          products: [products.dreamAlignTopper, products.dreamAlignSideTopper],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            label: 'Both upper and lower body',
            icon: '\uD83D\uDD34',
            next: {
              id: 'q3e',
              question: 'What level of investment are you ready for?',
              subtitle: 'We can address both areas at different price points',
              options: [
                {
                  label: 'Start with the essentials',
                  icon: '\uD83C\uDFAF',
                  result: {
                    title: 'Pillow + Topper Combo',
                    description: 'The DCOP aligns your neck and shoulders from above while the DreamAlign Topper supports your back and hips from below \u2014 the most efficient way to address full-body pain without replacing your mattress.',
                    products: [products.dcop, products.dreamAlignTopper],
                  },
                },
                {
                  label: 'I want a complete overhaul',
                  icon: '\uD83D\uDE80',
                  result: {
                    title: 'Pillow + Mattress Overhaul',
                    description: 'The DCOP handles cervical alignment while the DreamAlign Hybrid mattress targets 7 pressure points with AirFoam\u2122 and Tri-Zone Coils\u2122 \u2014 a full-body pain relief system from head to toe.',
                    products: [products.dcop, products.dreamAlignHybrid],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      label: 'No, but I have other sleep issues',
      icon: '\uD83D\uDE34',
      next: {
        id: 'q2b',
        question: 'What\u2019s your biggest sleep frustration?',
        subtitle: 'Let\u2019s zero in on what\u2019s keeping you from great sleep',
        options: [
          {
            label: 'I overheat / night sweats',
            icon: '\uD83C\uDF21\uFE0F',
            next: {
              id: 'q3c',
              question: 'What part of your sleep setup traps the most heat?',
              subtitle: 'We have cooling technology for every layer of your bed',
              options: [
                {
                  label: 'My pillow and head area',
                  icon: '\uD83E\uDDCA',
                  result: {
                    title: 'Pillow Cooling System',
                    description: 'The ThermaCool Adjustable has triple-cooling tech (cover + ventilated core + adjustable fill). Pair it with the ThermaCool Pillow Case for instant cool-to-touch contact.',
                    products: [products.thermacoolPillow, products.thermacoolCase],
                  },
                },
                {
                  label: 'My sheets and covers',
                  icon: '\uD83D\uDECF\uFE0F',
                  result: {
                    title: 'Cooling Bedding Set',
                    description: 'The ThermaCool Sheet Set\u2019s bamboo blend wicks moisture and channels heat away from your body. The Comforter\u2019s NASA-inspired Phase-Change Micro-Gel actively regulates your temperature all night.',
                    products: [products.thermacoolSheets, products.thermacoolComforter],
                  },
                },
                {
                  label: 'My mattress holds heat',
                  icon: '\uD83D\uDD25',
                  result: {
                    title: 'Mattress Cooling Layer',
                    description: 'The ThermaCool Topper\u2019s embedded graphite-infused bands pull heat from where your body generates it most \u2014 lasting cooling that doesn\u2019t fade. Add the Sheet Set on top for a fully cool sleep surface.',
                    products: [products.thermacoolTopper, products.thermacoolSheets],
                  },
                },
              ],
            },
          },
          {
            label: 'Snoring or acid reflux / GERD',
            icon: '\uD83D\uDE24',
            next: {
              id: 'q3d',
              question: 'Do you also experience neck pain or stiffness?',
              subtitle: 'We can address multiple issues with the right combination',
              options: [
                {
                  label: 'Yes, my neck bothers me too',
                  icon: '\uD83D\uDE23',
                  result: {
                    title: 'Elevation + Neck Support',
                    description: 'The Wedge Pillow\u2019s incline opens airways and prevents acid reflux. The DCOP\u2019s contoured design keeps your neck and spine perfectly aligned \u2014 together they solve both problems.',
                    products: [products.wedgePillow, products.dcop],
                  },
                },
                {
                  label: 'No, just the snoring / reflux',
                  icon: '\uD83D\uDC4C',
                  result: {
                    title: 'Therapeutic Elevation',
                    description: 'The Wedge Pillow uses gravity to keep stomach acid down and airways open. The cooling gel layer under the ThermaCool cover keeps you comfortable throughout the night.',
                    products: [products.wedgePillow],
                  },
                },
              ],
            },
          },
          {
            label: 'I just want better sleep quality',
            icon: '\u2728',
            next: {
              id: 'q3f',
              question: 'What sounds most appealing to you?',
              subtitle: 'Even without a specific problem, the right upgrade makes a huge difference',
              options: [
                {
                  label: 'A pillow that actually supports me',
                  icon: '\uD83D\uDE0C',
                  result: {
                    title: 'The Dosaze Signature Pillow',
                    description: 'There\u2019s a reason the DCOP has 1,310+ five-star reviews. The contoured design with proprietary memory foam delivers alignment and comfort that most people have never experienced from a pillow.',
                    products: [products.dcop],
                  },
                },
                {
                  label: 'Cooler, more comfortable bedding',
                  icon: '\u2744\uFE0F',
                  result: {
                    title: 'Complete Cooling Upgrade',
                    description: 'Transform your bed\u2019s feel with the ThermaCool Sheet Set\u2019s bamboo-blend breathability and the ThermaCool Pillow Case\u2019s instant cool-to-touch fabric. The easiest upgrade for noticeably better sleep.',
                    products: [products.thermacoolSheets, products.thermacoolCase],
                  },
                },
                {
                  label: 'A more supportive mattress feel',
                  icon: '\uD83D\uDCAA',
                  result: {
                    title: 'Mattress Transformation',
                    description: 'The DreamAlign Back Relief Topper\u2019s 3-zone support system and dual-layer foam turns any mattress into a properly supportive sleep surface \u2014 without the cost of a new mattress.',
                    products: [products.dreamAlignTopper],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
};

/* ─── QUIZ ENGINE ────────────────────────────────────────────────────────────
   Single class — satisfies ESLint max-classes-per-file rule.
──────────────────────────────────────────────────────────────────────────── */

class DszQuiz {
  constructor() {
    this._injectImages();

    this.overlay = document.getElementById('dsz-quiz');
    if (!this.overlay) return;

    this.body = document.getElementById('dsz-quiz-body');
    this.progressFill = document.getElementById('dsz-quiz-progress-fill');
    this.stepLabel = document.getElementById('dsz-quiz-step-label');
    this.backBtn = document.getElementById('dsz-quiz-back');
    this.progressSection = this.overlay.querySelector('.dsz-quiz__progress');
    this.progressTrack = document.getElementById('dsz-quiz-progress-track');

    this.path = [];
    this.result = null;
    this.totalSteps = 3;
    this.triggerEl = null;
    this.isOpen = false;
    this.flickityInstance = null;
    this._transitioning = false;

    this._bindEvents();
  }

  // ── Merge Liquid-injected image URLs into the products object ──────────────

  _injectImages() {
    const el = document.getElementById('dsz-quiz-product-images');
    if (!el) return;
    try {
      const images = JSON.parse(el.textContent);
      Object.keys(images).forEach(key => {
        if (products[key] && images[key]) {
          products[key].image = images[key];
        }
      });
    } catch (_e) {
      // Images fall back to blank — cards still render without photos
    }
  }

  // ── Event bindings ─────────────────────────────────────────────────────────

  _bindEvents() {
    // Open: any element with [data-dsz-quiz-open]
    document.querySelectorAll('[data-dsz-quiz-open]').forEach(btn => {
      btn.addEventListener('click', () => {
        this.triggerEl = btn;
        this.open();
      });
    });

    // Close: X button
    const closeBtn = this.overlay.querySelector('[data-dsz-quiz-close]');
    if (closeBtn) closeBtn.addEventListener('click', () => this.close());

    // Close: backdrop click (only when target IS the overlay itself)
    this.overlay.addEventListener('click', e => {
      if (e.target === this.overlay) this.close();
    });

    // Back button in sticky header
    if (this.backBtn) {
      this.backBtn.addEventListener('click', () => this._handleBack());
    }

    // Escape key
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && this.isOpen) this.close();
    });
  }

  // ── Open / close ───────────────────────────────────────────────────────────

  open() {
    this.isOpen = true;

    // Reset state to Q1
    this.path = [];
    this.result = null;
    this.totalSteps = 3;
    this._transitioning = false;

    // Show overlay
    this.overlay.setAttribute('aria-hidden', 'false');
    this.overlay.classList.add('dsz-quiz--open');
    document.body.style.overflow = 'hidden';

    // Pause Flickity slideshow so it doesn't advance behind the modal
    const flickityEl = document.querySelector('[id^="Slideshow-"].hero');
    if (flickityEl && window.Flickity) {
      this.flickityInstance = window.Flickity.data(flickityEl);
      if (this.flickityInstance) this.flickityInstance.pausePlayer();
    }

    // Render Q1 into the body
    if (this.body) this.body.classList.remove('dsz-quiz__body--fading');
    this._render();

    // GA4: quiz opened
    if (typeof gtag === 'function') {
      const loc = this.triggerEl && this.triggerEl.classList.contains('dsz-quiz-trigger--nav') ? 'header' : 'hero';
      gtag('event', 'sleep_quiz_open', { trigger_location: loc });
    }

    // Shift focus to the close button for screen-reader accessibility
    const closeBtn = this.overlay.querySelector('[data-dsz-quiz-close]');
    if (closeBtn) {
      setTimeout(() => closeBtn.focus(), 50);
    }
  }

  close() {
    // GA4: quiz abandoned (closed before reaching results)
    if (typeof gtag === 'function' && !this.result) {
      gtag('event', 'sleep_quiz_abandoned', { steps_completed: this.path.length });
    }

    this.isOpen = false;

    this.overlay.setAttribute('aria-hidden', 'true');
    this.overlay.classList.remove('dsz-quiz--open');
    document.body.style.overflow = '';

    // Resume Flickity
    if (this.flickityInstance) {
      this.flickityInstance.unpausePlayer();
      this.flickityInstance = null;
    }

    // Return focus to the trigger element that opened the quiz
    if (this.triggerEl) this.triggerEl.focus();
  }

  // ── Navigation ─────────────────────────────────────────────────────────────

  _getCurrentNode() {
    let node = tree;
    for (const idx of this.path) {
      const opt = node.options[idx];
      if (opt && opt.next) {
        node = opt.next;
      } else {
        return null;
      }
    }
    return node;
  }

  _handleSelect(i) {
    const node = this._getCurrentNode();
    if (!node) return;
    const opt = node.options[i];
    if (!opt) return;

    this._fadeTransition(() => {
      if (opt.result) {
        this.result = opt.result;
      } else if (opt.next) {
        const newPath = [...this.path, i];
        this.path = newPath;

        // Detect the one 4-step path: back/hips → enhance current mattress
        // hasDeeper is true when the next question's options have further branching
        const hasDeeper = opt.next.options.some(o => o.next);
        if (hasDeeper && newPath.length === 2) {
          this.totalSteps = 4;
        }
      }
    });
  }

  _handleBack() {
    // Guard: can't go back on Q1 without a result
    if (this.result === null && this.path.length === 0) return;

    this._fadeTransition(() => {
      if (this.result) {
        this.result = null;
      } else {
        this.path = this.path.slice(0, -1);
        // Reset totalSteps if we've backed up past the branch point
        if (this.path.length < 2) this.totalSteps = 3;
      }
    });
  }

  _handleReset() {
    this._fadeTransition(() => {
      this.path = [];
      this.result = null;
      this.totalSteps = 3;
    });
  }

  // ── Fade transition between steps ─────────────────────────────────────────

  _fadeTransition(callback) {
    if (!this.body || this._transitioning) return;
    this._transitioning = true;

    this.body.classList.add('dsz-quiz__body--fading');

    setTimeout(() => {
      callback();
      this._render();

      // Scroll body back to top for the new content
      this.body.scrollTop = 0;

      // Force a reflow so the browser registers the class removal as a new transition
      // eslint-disable-next-line no-unused-expressions
      this.body.offsetHeight;

      this.body.classList.remove('dsz-quiz__body--fading');
      this._transitioning = false;
    }, 220);
  }

  // ── Render coordinator ────────────────────────────────────────────────────

  _render() {
    if (!this.body) return;

    if (this.result) {
      // Results mode: hide progress track + step label, keep back button
      if (this.stepLabel) this.stepLabel.style.display = 'none';
      if (this.progressTrack) this.progressTrack.style.display = 'none';
      if (this.backBtn) {
        this.backBtn.style.display = '';
        this.backBtn.textContent = '\u2190 Back';
      }
      this._renderResults(this.result);
    } else {
      // Question mode: show progress
      const step = this.path.length + 1;

      if (this.stepLabel) {
        this.stepLabel.style.display = '';
        this.stepLabel.textContent = `Question ${step} of ${this.totalSteps}`;
      }
      if (this.progressFill) {
        this.progressFill.style.width = `${(step / this.totalSteps) * 100}%`;
      }
      if (this.progressTrack) this.progressTrack.style.display = '';
      if (this.backBtn) {
        this.backBtn.style.display = this.path.length > 0 ? '' : 'none';
      }

      const node = this._getCurrentNode();
      if (node) this._renderQuestion(node);
    }
  }

  // ── HTML helpers ──────────────────────────────────────────────────────────

  // Safe HTML escaping for user-facing strings built into innerHTML
  _esc(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // ── Question renderer ─────────────────────────────────────────────────────

  _renderQuestion(node) {
    let html = `<h2 class="dsz-quiz__question">${this._esc(node.question)}</h2>`;
    html += `<p class="dsz-quiz__subtitle">${this._esc(node.subtitle)}</p>`;
    html += '<div class="dsz-quiz__options" role="list">';

    node.options.forEach((opt, i) => {
      html += `<button type="button" class="dsz-quiz__option" role="listitem" data-option="${i}">`;
      html += `<span class="dsz-quiz__option-icon" aria-hidden="true">${opt.icon}</span>`;
      html += `<span class="dsz-quiz__option-label">${this._esc(opt.label)}</span>`;
      html += '<span class="dsz-quiz__option-arrow" aria-hidden="true">\u2192</span>';
      html += '</button>';
    });

    html += '</div>';
    this.body.innerHTML = html;

    // Bind click events after inserting into DOM
    this.body.querySelectorAll('.dsz-quiz__option').forEach(btn => {
      btn.addEventListener('click', () => {
        this._handleSelect(parseInt(btn.dataset.option, 10));
      });
    });
  }

  // ── Results renderer ──────────────────────────────────────────────────────

  _renderResults(result) {
    const isSingle = result.products.length === 1;

    let html = '<div class="dsz-quiz__results">';

    // Header: badge + title + description
    html += '<div class="dsz-quiz__results-header">';
    html += '<span class="dsz-quiz__recommendation-badge">Your Recommendation</span>';
    html += `<h2 class="dsz-quiz__results-title">${this._esc(result.title)}</h2>`;
    html += `<p class="dsz-quiz__results-desc">${this._esc(result.description)}</p>`;
    html += '</div>';

    // Product cards
    html += `<div class="dsz-quiz__products${isSingle ? ' dsz-quiz__products--single' : ''}">`;

    result.products.forEach(p => {
      const hasBadge = Boolean(p.tag);
      html += `<div class="dsz-quiz__product-card${hasBadge ? ' dsz-quiz__product-card--bestseller' : ''}">`;

      if (hasBadge) {
        html += `<div class="dsz-quiz__product-badge">${this._esc(p.tag)}</div>`;
      }

      if (p.image) {
        html += '<div class="dsz-quiz__product-img-wrap">';
        html += `<img src="${p.image}" alt="${this._esc(p.name)}" class="dsz-quiz__product-img" loading="lazy" width="400" height="400">`;
        html += '</div>';
      }

      html += '<div class="dsz-quiz__product-content">';
      html += '<div class="dsz-quiz__product-name-row">';
      html += `<h3 class="dsz-quiz__product-name">${this._esc(p.name)}</h3>`;
      html += `<span class="dsz-quiz__product-price">${this._esc(p.price)}</span>`;
      html += '</div>';

      html += '<ul class="dsz-quiz__product-points">';
      p.points.forEach(pt => {
        html += '<li class="dsz-quiz__product-point">';
        html += '<span class="dsz-quiz__product-check" aria-hidden="true">\u2713</span>';
        html += `<span>${this._esc(pt)}</span>`;
        html += '</li>';
      });
      html += '</ul>';

      html += `<a href="${p.url}" class="dsz-quiz__view-btn" target="_blank" rel="noopener noreferrer">View Product \u2192</a>`;
      html += '</div>'; // product-content
      html += '</div>'; // product-card
    });

    html += '</div>'; // products

    // Start Over
    html += '<div class="dsz-quiz__reset-wrap">';
    html += '<button type="button" class="dsz-quiz__reset" id="dsz-quiz-reset">\u21BA Start Over</button>';
    html += '</div>';

    html += '</div>'; // results
    this.body.innerHTML = html;

    // GA4: quiz completed — results shown
    if (typeof gtag === 'function') {
      gtag('event', 'sleep_quiz_complete', { result_title: result.title });
    }

    // Bind reset button
    const resetBtn = document.getElementById('dsz-quiz-reset');
    if (resetBtn) {
      resetBtn.addEventListener('click', () => this._handleReset());
    }
  }
}

// ─── INIT ─────────────────────────────────────────────────────────────────────

document.addEventListener('DOMContentLoaded', () => {
  new DszQuiz(); // eslint-disable-line no-new
});
